import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};
var _hoisted_2 = ["onClick"];
import * as pathToRegexp from 'path-to-regexp';

import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup: function setup(__props) {
    var levelList = ref([]);
    var route = useRoute();
    var router = useRouter();
    getBreadcrumb();
    watch(route, function () {
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      getBreadcrumb();
    });
    function getBreadcrumb() {
      // only show routes with meta.title
      var matched = route.matched.filter(function (item) {
        return item.meta && item.meta.title;
      });
      var first = matched[0];
      if (!isHome(first)) {
        matched.unshift({
          path: '/home',
          meta: {
            title: '主页'
          },
          name: ''
        });
      }
      levelList.value = matched.filter(function (item) {
        return item.meta && item.meta.title && item.meta.breadcrumb !== false;
      });
    }
    function isHome(route) {
      var name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase();
    }
    function pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      var params = route.params;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    }
    function handleLink(item) {
      var redirect = item.redirect,
        path = item.path;
      if (redirect) {
        router.push(redirect);
        return;
      }
      router.push(pathCompile(path));
    }
    return function (_ctx, _cache) {
      var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "app-breadcrumb",
        separator: "/"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_TransitionGroup, {
            name: "breadcrumb"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(levelList), function (item, index) {
                return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
                  key: item.path
                }, {
                  default: _withCtx(function () {
                    return [item.redirect === 'noRedirect' || index == _unref(levelList).length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1)) : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _withModifiers(function ($event) {
                        return handleLink(item);
                      }, ["prevent"])
                    }, _toDisplayString(item.meta.title), 9, _hoisted_2))];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
});